<script lang="ts">
    export let href: string|undefined = undefined;
    export let size: App.SizeName = 'md';
    export let disabled: boolean|undefined = undefined;
    export let color: App.ColorName = 'primary';
</script>

{#if href === undefined}
    <button {disabled} type="button" class="btn btn-basic {size} {color}" on:click>
        <span class="btn-container">
            <slot />
        </span>
    </button>
    {:else}
    <a {href} class="btn btn-basic btn-link {size} {color}">
        <span class="btn-container">
            <slot />
        </span>
    </a>
{/if}